import type { ValidationRules } from "../forms";

/**
 * Field-level constraints for audit finding responses (US-082).
 *
 * The response route was previously BARE — bounds are new policy written to
 * the handler-read body shape. Shared by CreateFindingResponseSchema
 * (backend) and FindingResponseModal (frontend). response_type enum and the
 * conditional requirements (action_plan when type=action_plan,
 * evidence_description when type=completion_evidence) stay bespoke.
 */
export const FINDING_RESPONSE_FIELD_RULES = {
  response_text: { required: true, maxLength: 2000 },
  action_plan: { maxLength: 2000 },
  responsible_person: { maxLength: 200 },
  evidence_description: { maxLength: 2000 },
} satisfies Record<string, ValidationRules>;

export const FINDING_RESPONSE_FIELD_LABELS: Record<
  keyof typeof FINDING_RESPONSE_FIELD_RULES,
  string
> = {
  response_text: "Response",
  action_plan: "Action plan",
  responsible_person: "Responsible person",
  evidence_description: "Evidence description",
};
